//se modifico
import getImage from "./GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import htmlToPdfmake from "html-to-pdfmake";
import moment from "moment";
import { getUser } from "../../../../Utils/CurrentUser";
import { calculateAgeParse, concatenateNames } from "../../../../Utils/Patient";
import {
  validateProcessECO,
  validateProcessEstres,
  validateProcessPrueba,
  validateProcessEKG,
  validateProcessHolter,
  validateProcessMapa,
} from "../../../../Utils/UtilOtherProcedures";
import { sendPDFToEmail } from "./SenderDocumentWithEmail";

const clinicHystoryPDF = async (
  data,
  opt,
  emailsDestiny,
  printCurrentHistory = false
) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };

  console.log("datos de la historia completa", data);
  const fecha = moment(new Date()).format("DD-MM-YYYY h:mm");
  const name =
    data.typeOfDocument + "-" + data.documentNumber + " " + data.names;
  const clinicType = JSON.parse(sessionStorage.getItem("centroTipos"));
  const lengthAdmissions = data.admissions.length;
  const supportDoc = data.medicoApoyo;

  let listAlergies = data.alergies
    ? data.alergies.reduce((acc, current, idx) => {
        if (data.alergies.length - 1 === idx) {
          return acc.concat(current.nombre);
        } else {
          return acc.concat(current.nombre + " - ");
        }
      }, "")
    : "";

  const header = {
    margin: [40, 10, 30, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text: !data.profile.length
              ? data.profile.nombre +
                "\n Nit: " +
                data.profile.nit +
                "\n" +
                data.profile.direccion.direccion +
                " \n Teléfonos: " +
                data.profile.telefono1 +
                "-" +
                data.profile.telefono2 +
                " \n Fecha: " +
                data.day
              : "",
            style: "head",
          },
        ],
      ],
    },
  };

  const printSignature = async (admission) => {
    let urlServe = `${process.env.REACT_APP_PUBLIC_URL}profesional/ver-firma/${
      admission.id_profesional
    }/${sessionStorage.getItem("token")}`;
    let urlFirma = "https://i.postimg.cc/0jznYVsr/prueba.png";
    let test = fetch(urlServe)
      .then((response) => {
        if (response.status === 500) {
          return false;
        } else {
          return true;
        }
      })
      .catch((err) => console.log(err));

    let isImg = await test;
    if (isImg) urlFirma = urlServe;
    return urlFirma;
  };

  let docContent = [];

  const neurologicalEvaluation = (curAdmissionNeuro) => {
    let cranialNerves = curAdmissionNeuro.nevios_craniales.cranialNerves;
    let conscienceText =
      curAdmissionNeuro.conciencia.conscience.option === "otro"
        ? curAdmissionNeuro.conciencia.conscience.option +
          " Cual:" +
          curAdmissionNeuro.conciencia.conscience.cual
        : curAdmissionNeuro.conciencia.conscience.option;
    try {
      if (Object.keys(curAdmissionNeuro).length) {
        //neurologicalEvaluation
        return {
          margin: [0, 20, 0, 10],
          pageOrientation: "portrait",
          layout: {
            defaultBorder: false,
          },
          table: {
            widths: ["auto", "*"],
            body: [
              [
                {
                  text: "Examen Neurológico: ",
                  bold: true,
                  fontSize: 10,
                  border: [false, false, false, true],
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: "Conciencia: " + conscienceText,
                  bold: true,
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: "Nervios Craneales ",
                  bold: true,
                  fontSize: 10,
                  border: [false, false, false, true],
                  colSpan: 2,
                },
                "",
              ],
              [
                { text: "Funciones: ", bold: true, fontSize: 10, colSpan: 2 },
                "",
              ],
              [
                {
                  text: `${cranialNerves[0].name} : ${cranialNerves[0].description}`,
                  style: "textStyle",
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: `${cranialNerves[1].name} : ${cranialNerves[1].description}`,
                  style: "textStyle",
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: `${cranialNerves[2].name} : ${cranialNerves[2].description}`,
                  style: "textStyle",
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: `${cranialNerves[3].name} : ${cranialNerves[3].description}`,
                  style: "textStyle",
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: `${cranialNerves[4].name} : ${cranialNerves[4].description}`,
                  style: "textStyle",
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: `${cranialNerves[5].name} : ${cranialNerves[5].description}`,
                  style: "textStyle",
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: `${cranialNerves[6].name} : ${cranialNerves[6].description}`,
                  style: "textStyle",
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: `${cranialNerves[7].name} : ${cranialNerves[7].description}`,
                  style: "textStyle",
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: `${cranialNerves[8].name} : ${cranialNerves[8].description}`,
                  style: "textStyle",
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: "Sistema Motor ",
                  bold: true,
                  fontSize: 10,
                  border: [false, false, false, true],
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text:
                    "Fuerza: " +
                    curAdmissionNeuro.sistema_motor.motorsystem.fuerza,
                  bold: true,
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: "0 a 4 | 0 = Plejia, 1 = hipo, 2 = normal, 3 = vivos, 4 = hiper ",
                  bold: true,
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: `ROT: -+ Babinski: ${curAdmissionNeuro.sistema_motor.motorsystem.rot.left} | -+ Babinski: ${curAdmissionNeuro.sistema_motor.motorsystem.rot.rigth}`,
                  bold: true,
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: "Sistema Sensitivo: ",
                  bold: true,
                  fontSize: 10,
                  border: [false, false, false, true],
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: curAdmissionNeuro.sistema_sensitivo.sensitiveSystem,
                  fontSize: 10,
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: "Taxias: ",
                  bold: true,
                  fontSize: 10,
                  border: [false, false, false, true],
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: curAdmissionNeuro.taxias.taxis.pin
                    ? `PIN: ${curAdmissionNeuro.taxias.taxis.pin}`
                    : "PIN:",
                  bold: true,
                  fontSize: 10,
                },
                {
                  text: curAdmissionNeuro.taxias.taxis.ptr
                    ? `PTR: ${curAdmissionNeuro.taxias.taxis.ptr}`
                    : "PTR: ",
                  bold: true,
                  fontSize: 10,
                },
              ],
              [
                { text: "Marcha: ", bold: true, fontSize: 10 },
                {
                  text: curAdmissionNeuro.taxias.taxis.marcha,
                  bold: true,
                  fontSize: 10,
                },
              ],
              [
                {
                  text: "Signos de Irritación Meningea: ",
                  bold: true,
                  fontSize: 10,
                  border: [false, false, false, true],
                  colSpan: 2,
                },
                "",
              ],
              [
                {
                  text: curAdmissionNeuro.meningea.signsMeningealIrritation,
                  fontSize: 10,
                  border: [false, false, false, true],
                  colSpan: 2,
                },
                "",
              ],
            ],
          },
        };
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  };

  for (let i = 0; i < data.admissions.length; i++) {
    const currentAdmission = data.admissions[i];
    let url_doctor =
      process.env.REACT_APP_PUBLIC_URL +
      currentAdmission.url_firma_doctor +
      "/" +
      sessionStorage.getItem("token");

    let tableBodySignatures = [
      {
        // auto-sized columns have their widths based on their content
        unbreakable: true,
        layout: "headerLineOnly",
        border: [false, false, false, false],
        table: {
          widths: [125],
          headerRows: 1,
          alignment: "center",
          body: [
            [
              {
                image: await getImage(data.firmDoctor),
                fit: [100, 25],
                alignment: "center",
              },
            ],
            [
              {
                text:
                  "Dra. " +
                  currentAdmission.nombres +
                  " " +
                  currentAdmission.apellido1 +
                  " " +
                  currentAdmission.apellido2 +
                  "\n" +
                  currentAdmission.especialidad +
                  "\n REG-" +
                  currentAdmission.reg_medico,
                style: "medicStyle",
              },
            ],
          ],
        },
      },
    ];

    let tableBodySignatures1 = [
      {
        // auto-sized columns have their widths based on their content
        unbreakable: true,
        layout: "headerLineOnly",
        border: [false, false, false, false],
        table: {
          widths: [125],
          headerRows: 1,
          alignment: "center",
          body: [
            [
              {
                image: await getImage(data.firmDoctor),
                fit: [100, 25],
                alignment: "center",
              },
            ],
            [
              {
                text:
                  "Dr. " +
                  currentAdmission.nombres +
                  " " +
                  currentAdmission.apellido1 +
                  " " +
                  currentAdmission.apellido2 +
                  "\n" +
                  currentAdmission.especialidad +
                  "\n REG-" +
                  currentAdmission.reg_medico,
                style: "medicStyle",
              },
            ],
          ],
        },
      },
    ];

    let tableBodySignatures2 = [
      {
        // auto-sized columns have their widths based on their content
        unbreakable: true,
        layout: "headerLineOnly",
        border: [false, false, false, false],
        table: {
          widths: [125],
          headerRows: 1,
          alignment: "center",
          body: [
            [
              {
                image: await getImage(url_doctor),
                fit: [150, 80],
                alignment: "center",
              },
            ],
            [
              {
                text:
                  "Dr. " +
                  currentAdmission.nombres +
                  " " +
                  currentAdmission.apellido1 +
                  " " +
                  currentAdmission.apellido2 +
                  "\n" +
                  currentAdmission.especialidad +
                  "\n REG-" +
                  currentAdmission.reg_medico,
                style: "medicStyle",
              },
            ],
          ],
        },
      },
    ];

    for (let j = 0; j < supportDoc.length; j++) {
      let supportDocInfo = supportDoc[j];
      let firmUrl = data.firmDoctorSupport[j];

      if (data.suportDoc !== null) {
        tableBodySignatures.push({
          unbreakable: true,
          layout: "headerLineOnly",
          border: [false, false, false, false],
          table: {
            widths: [125],
            headerRows: 1,
            alignment: "center",
            body: [
              [
                {
                  image: await getImage(firmUrl),
                  fit: [100, 25],
                  alignment: "center",
                },
              ],
              [
                {
                  text:
                    supportDocInfo.titulo +
                    " " +
                    supportDocInfo.nombres +
                    " " +
                    supportDocInfo.apellido1 +
                    "\n" +
                    supportDocInfo.especialidad +
                    "\nREG-" +
                    supportDocInfo.reg_medico,
                  style: "medicStyle",
                },
              ],
            ],
          },
        });
        tableBodySignatures1.push({
          unbreakable: true,
          layout: "headerLineOnly",
          border: [false, false, false, false],
          table: {
            widths: [125],
            headerRows: 1,
            alignment: "center",
            body: [
              [
                {
                  image: await getImage(firmUrl),
                  fit: [100, 25],
                  alignment: "center",
                },
              ],
              [
                {
                  text:
                    supportDocInfo.titulo +
                    " " +
                    supportDocInfo.nombres +
                    " " +
                    supportDocInfo.apellido1 +
                    "\n" +
                    supportDocInfo.especialidad +
                    "\nREG-" +
                    supportDocInfo.reg_medico,
                  style: "medicStyle",
                },
              ],
            ],
          },
        });
        /* tableBodySignatures2.push({
          unbreakable: true,
          layout: "headerLineOnly",
          border: [false, false, false, false],
          table: {
            widths: [125],
            headerRows: 1,
            alignment: "center",
            body: [
              /* [
                {
                  image: await getImage(firmUrl),
                  fit: [100, 25],
                  alignment: "center",
                },
              ],
              [
                {
                  text:
                    supportDocInfo.titulo +
                    " " +
                    supportDocInfo.nombres +
                    " " +
                    supportDocInfo.apellido1 +
                    "\n" +
                    supportDocInfo.especialidad +
                    "\nREG-" +
                    supportDocInfo.reg_medico,
                  style: "medicStyle",
                },
              ],
            ],
          },
        }); */
      }
    }

    let signatures = [
      {
        unbreakable: true,
        pageBreak: "after",
        margin: [10, 20, 50, 0],
        layout: {
          paddingTop: function (index, node) {
            applyVerticalAlignment(node, index, "bottom");
            return 0;
          },
          defaultBorder: false,
        },
        table: {
          widths: ["*", "*", "*"],
          headerRows: 1,
          body: [tableBodySignatures],
        },
      },
    ];

    let signatures1 = [
      {
        unbreakable: true,
        pageBreak: i + 1 === lengthAdmissions ? "" : "after",
        margin: [10, 20, 50, 0],
        layout: {
          paddingTop: function (index, node) {
            applyVerticalAlignment(node, index, "bottom");
            return 0;
          },
          defaultBorder: false,
        },
        table: {
          widths: ["*", "*", "*"],
          headerRows: 1,
          body: [tableBodySignatures1],
        },
      },
    ];

    let signatures2 = [
      {
        unbreakable: true,
        pageBreak: i + 1 === lengthAdmissions ? "" : "after",
        margin: [10, 20, 50, 0],
        layout: {
          paddingTop: function (index, node) {
            applyVerticalAlignment(node, index, "bottom");
            return 0;
          },
          defaultBorder: false,
        },
        table: {
          widths: ["*", "*", "*"],
          headerRows: 1,
          body: [tableBodySignatures2],
        },
      },
    ];

    const dataLegalRepresent = () => {
      const legalRepresententes = [];

      let hasInformation = false;

      hasInformation = Object.values(
        currentAdmission.representante_legal[0]
      ).some((val) => val != "");

      legalRepresententes.push([
        {
          text: "Datos del Representente Legal",
          style: "tableheader",
          border: [false, false, false, true],
          colSpan: 4,
        },
        "",
        "",
        "",
      ]);

      hasInformation === false
        ? legalRepresententes.push([
            {
              text: "No suministra información",
              style: "textRepresentandCompanion",
              colSpan: 4,
            },
            "",
            "",
            "",
          ])
        : null;

      if (hasInformation) {
        for (let k = 0; k < currentAdmission.representante_legal.length; k++) {
          const currentLegalReprensent =
            currentAdmission.representante_legal[k];

          if (currentLegalReprensent) {
            legalRepresententes.push([
              {
                text: "Nombre:  ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentLegalReprensent.nombre_completo,
                style: "textStyle",
              },
              {
                text: "Identificación: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentLegalReprensent.num_documento,
                style: "textStyle",
              },
            ]);
            legalRepresententes.push([
              {
                text: "Teléfonos: ",
                bold: true,
                style: "textStyle",
              },
              {
                text:
                  currentLegalReprensent.telefono1 +
                  " / " +
                  currentLegalReprensent.telefono2,
                style: "textStyle",
              },
              {
                text: "Parentesco: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentLegalReprensent.parentesco,
                style: "textStyle",
              },
            ]);
            legalRepresententes.push([{}, {}, {}, {}]);
          }
        }
      }

      return legalRepresententes;
    };

    const dataCompanion = () => {
      const companions = [];

      let hasInformation =
        currentAdmission.acompanante !== null &&
        currentAdmission.acompanante.length > 0;

      companions.push([
        {
          text: "Datos del Acompañante",
          style: "tableheader",
          border: [false, false, false, true],
          colSpan: 4,
        },
        "",
        "",
        "",
      ]);

      hasInformation === false
        ? companions.push([
            {
              text: "Sin acompañante",
              style: "textRepresentandCompanion",
              colSpan: 4,
            },
            "",
            "",
            "",
          ])
        : null;

      if (hasInformation) {
        for (let k = 0; k < currentAdmission.acompanante.length; k++) {
          const currentCompanion = currentAdmission.acompanante[k];

          if (currentCompanion) {
            companions.push([
              {
                text: "Nombre:  ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentCompanion.nombre,
                style: "textStyle",
              },
              {
                text: "Identificación: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentCompanion.num_documento,
                style: "textStyle",
              },
            ]);
            companions.push([
              {
                text: "Teléfonos: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentCompanion.tel1 + " / " + currentCompanion.tel2,
                style: "textStyle",
              },
              {
                text: "Parentesco: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentCompanion.parentesco,
                style: "textStyle",
              },
            ]);
            companions.push([{}, {}, {}, {}]);
          }
        }
      }

      return companions;
    };

    const basicPatientInfo = () => {
      const dataTiposDisability = () => {
        const tipos = data.disability.discapacidades.map((d) => {
          const subtipos = d.tipo.map((t) => t.nombre).join(", ");
          return {
            text: [{ text: `${d.nombre}: `, bold: true }, subtipos + "\n"],

            margin: [0, 2, 0, 0],
          };
        });

        return [
          {
            columns: [
              {
                text: "Tipo de discapacidad",
                bold: true,
                margin: [20, 0, 0, 0],
              },
            ],
            margin: [0, 10, 0, 2],
          },
          ...tipos,
        ];
      };

      return {
        // auto-sized columns have their widths based on their content
        margin: [0, 10, 0, 10],
        layout: {
          defaultBorder: false,
        },
        table: {
          headerRows: 1,
          widths: ["auto", "*", "auto", "*"],
          body: [
            [
              {
                text: "Datos del Paciente",
                style: "tableheader",
                border: [false, false, false, true],
                colSpan: 2,
              },
              "",
              {
                text: "Admisión: " + currentAdmission.id_admision,
                style: "tableheader",
                border: [false, false, false, true],
              },
              {
                text: clinicType.includes("5")
                  ? "Fecha Atención: " +
                    moment(
                      `${currentAdmission.fecha} ${currentAdmission.hora}`
                    ).format("DD-MM-YYYY h:mm a")
                  : "Fecha Atención: " +
                    moment(
                      `${currentAdmission.fecha} ${currentAdmission.hora}`
                    ).format("DD-MM-YYYY h:mm a"),
                style: "tableheader",
                border: [false, false, false, true],
              },
            ],
            [
              { text: "Nombre: ", bold: true, style: "textStyle" },
              { text: data.names, style: "textStyle" },
              { text: "Identificación: ", bold: true, style: "textStyle" },
              {
                text: data.typeOfDocument + "-" + data.documentNumber,
                style: "textStyle",
              },
            ],
            [
              { text: "Fecha Nacimiento:", bold: true, style: "textStyle" },
              {
                text: moment(data.birthday).format("DD-MM-YYYY"),
                style: "textStyle",
              },
              { text: "Edad:", bold: true, style: "textStyle" },
              { text: calculateAgeParse(data.birthday), style: "textStyle" },
            ],
            [
              { text: "Género: ", bold: true, style: "textStyle" },
              { text: data.gender, style: "textStyle" },
              { text: "Tipo de Sangre: ", bold: true, style: "textStyle" },
              { text: data.bloodType, style: "textStyle" },
            ],
            [
              { text: "Dirección: ", bold: true, style: "textStyle" },
              { text: data.address, style: "textStyle" },
              { text: "Ciudad: ", bold: true, style: "textStyle" },
              { text: data.city, style: "textStyle" },
            ],
            [
              { text: "Estado Civil: ", bold: true, style: "textStyle" },
              { text: data.civilStatus, style: "textStyle" },
              { text: "Teléfonos: ", bold: true, style: "textStyle" },
              {
                text:
                  data.cellphone === null
                    ? data.telephone
                    : data.telephone + " / " + data.cellphone,
                style: "textStyle",
              },
            ],
            [
              {
                text: "Entidad: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentAdmission.cita.nombre_entidad,
                style: "textStyle",
              },
              {
                text: "Régimen: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: currentAdmission.cita.regimen,
                style: "textStyle",
              },
            ],
            [
              {
                text: "Ocupación: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: data.occupation?.nombre ?? null,
                style: "textStyle",
              },
              {
                text: "Población vulnerable: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: data.poblacionVulnerable ?? null,
                style: "textStyle",
              },
            ],
            [
              {
                text: "Discapacidad: ",
                bold: true,
                style: "textStyle",
              },
              {
                text: data.disability?.discapacidad ?? null,
                style: "textStyle",
              },
              data.disability?.discapacidad === "Si"
                ? {
                    text: "Tipo de Discapacidad: ",
                    bold: true,
                    style: "textStyle",
                  }
                : null,
              data.disability?.discapacidad === "Si"
                ? {
                    text: dataTiposDisability(),
                    style: "textStyle",
                  }
                : null,
            ],
            ["", "", "", ""],
            ...dataLegalRepresent(),
            ...dataCompanion(),
          ],
        },
      };
    };

    try {
      if (currentAdmission.anamnesis) {
        //let admissionSignature = await printSignature(currentAdmission);
        if (currentAdmission.procedimientos) {
          let resultsPocedures = [];
          if (
            currentAdmission.procedimientos.eco.hasOwnProperty("eco") ||
            currentAdmission.procedimientos.estres.hasOwnProperty("estres") ||
            currentAdmission.procedimientos.prueba.hasOwnProperty("prueba") ||
            currentAdmission.procedimientos.ekg.hasOwnProperty("ekg") ||
            currentAdmission.procedimientos.holter.hasOwnProperty("holter") ||
            currentAdmission.procedimientos.mapa.hasOwnProperty("mapa")
          ) {
            let resultOtherProcedureEco = (await validateProcessECO(
              currentAdmission.procedimientos.eco.eco[0]
            ))
              ? currentAdmission.procedimientos.eco.eco[0].conclusiones
              : null;
            let resultOtherProcedureEstres = (await validateProcessEstres(
              currentAdmission.procedimientos.estres.estres[0]
            ))
              ? currentAdmission.procedimientos.estres.estres[0].conclusiones
              : null;
            let resultOtherProcedurePrueba = (await validateProcessPrueba(
              currentAdmission.procedimientos.prueba.prueba[0]
            ))
              ? currentAdmission.procedimientos.prueba.prueba[0].conclusiones
              : null;
            let resultOtherProcedureEkg = (await validateProcessEKG(
              currentAdmission.procedimientos.ekg.ekg[0]
            ))
              ? currentAdmission.procedimientos.ekg.ekg[0].conclusions !==
                  undefined &&
                currentAdmission.procedimientos.ekg.ekg[0].conclusions !== null
                ? currentAdmission.procedimientos.ekg.ekg[0].conclusions
                : currentAdmission.procedimientos.ekg.ekg[0].conclusion !==
                    undefined &&
                  currentAdmission.procedimientos.ekg.ekg[0].conclusion !== null
                ? currentAdmission.procedimientos.ekg.ekg[0].conclusion
                : null
              : null;
            let resultOtherProcedureHolter = (await validateProcessHolter(
              currentAdmission.procedimientos.holter.holter[0]
            ))
              ? currentAdmission.procedimientos.holter.holter[0].conclusion
              : null;
            let resultOtherProcedureMapa = (await validateProcessMapa(
              currentAdmission.procedimientos.mapa.mapa[0]
            ))
              ? currentAdmission.procedimientos.mapa.mapa[0].conclusion
              : null;

            if (resultOtherProcedureEco !== null) {
              let nameServ = currentAdmission.cita.servicio.servicios.filter(
                (serv) => serv.formato === "1"
              );
              if (nameServ.length) {
                resultsPocedures.push({
                  ["service_name"]: nameServ[0].nombre,
                  ["code_cups"]: nameServ[0].codigo,
                  ["result_procedure"]: resultOtherProcedureEco,
                });
              }
            }
            if (resultOtherProcedureEstres !== null) {
              let nameServ = currentAdmission.cita.servicio.servicios.filter(
                (serv) => serv.formato === "3"
              );
              if (nameServ.length) {
                resultsPocedures.push({
                  ["service_name"]: nameServ[0].nombre,
                  ["code_cups"]: nameServ[0].codigo,
                  ["result_procedure"]: resultOtherProcedureEstres,
                });
              }
            }
            if (resultOtherProcedurePrueba !== null) {
              let nameServ = currentAdmission.cita.servicio.servicios.filter(
                (serv) => serv.formato === "4"
              );
              if (nameServ.length) {
                resultsPocedures.push({
                  ["service_name"]: nameServ[0].nombre,
                  ["code_cups"]: nameServ[0].codigo,
                  ["result_procedure"]: resultOtherProcedurePrueba,
                });
              }
            }
            if (resultOtherProcedureEkg !== null) {
              let nameServ = currentAdmission.cita.servicio.servicios.filter(
                (serv) => serv.formato === "2"
              );
              if (nameServ.length) {
                resultsPocedures.push({
                  ["service_name"]: nameServ[0].nombre,
                  ["code_cups"]: nameServ[0].codigo,
                  ["result_procedure"]: resultOtherProcedureEkg,
                });
              }
            }
            if (resultOtherProcedureHolter !== null) {
              let nameServ = currentAdmission.cita.servicio.servicios.filter(
                (serv) => serv.formato === "6"
              );
              if (nameServ.length) {
                resultsPocedures.push({
                  ["service_name"]: nameServ[0].nombre,
                  ["code_cups"]: nameServ[0].codigo,
                  ["result_procedure"]: resultOtherProcedureHolter,
                });
              }
            }
            if (resultOtherProcedureMapa !== null) {
              let nameServ = currentAdmission.cita.servicio.servicios.filter(
                (serv) => serv.formato === "7"
              );
              if (nameServ.length) {
                resultsPocedures.push({
                  ["service_name"]: nameServ[0].nombre,
                  ["code_cups"]: nameServ[0].codigo,
                  ["result_procedure"]: resultOtherProcedureMapa,
                });
              }
            }
          }

          if (resultsPocedures.length > 0) {
            let tableBodyOtherProcedures = [];

            try {
              for (let k = 0; k < resultsPocedures.length; k++) {
                const search = "\n";
                const replaceWith = "<br />";
                const result = resultsPocedures[k].result_procedure
                  .split(search)
                  .join(replaceWith);
                //let htmlProceduresConclusion = htmlToPdfmake(result);
                let htmlProceduresConclusion = htmlToPdfmake(result, {
                  defaultStyles: {
                    table: {
                      width: ["*", "auto"],
                    },
                  },
                  tableAutoSize: true,
                });
                tableBodyOtherProcedures.push(
                  [{ text: "Procedimiento: ", style: "tableheader" }, ""],
                  [
                    {
                      text:
                        resultsPocedures[k].code_cups +
                        " " +
                        resultsPocedures[k].service_name,
                      bold: true,
                      alignment: "left",
                      colSpan: 2,
                      style: "textStyle",
                    },
                    "",
                  ],
                  [htmlProceduresConclusion, ""]
                );
              }
            } catch (error) {
              console.log(error);
            }

            docContent.push(basicPatientInfo(), {
              unbreakable: true,
              margin: [0, 5, 0, 5],
              layout: "noBorders",
              table: {
                headerRows: 1,
                widths: ["auto", "*"],
                body: tableBodyOtherProcedures,
              },
            });
          }
        }

        if (currentAdmission.anamnesis) {
          const patientInfo = basicPatientInfo();
          docContent.push(patientInfo);
          docContent.push({
            margin: [0, 0, 0, 10],
            layout: {
              defaultBorder: false,
            },
            table: {
              widths: ["*"],
              headerRows: 1,
              body: [
                [
                  {
                    text: "Anamnesis ",
                    style: "tableheader",
                    border: [false, false, false, true],
                  },
                ],
                [
                  {
                    text: "Motivo de Consulta ",
                    bold: true,
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text:
                      currentAdmission.anamnesis.motivo_consulta !== null
                        ? currentAdmission.anamnesis.motivo_consulta
                        : "",
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text: "Enfermedad Actual ",
                    bold: true,
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text:
                      currentAdmission.anamnesis.enfermedad_actual !== null
                        ? currentAdmission.anamnesis.enfermedad_actual
                        : "",
                    style: "textStyle",
                  },
                ],
              ],
            },
          });
        }
        if (!currentAdmission.neurological_evaluation) {
          const {
            habitos: { habitos = [] } = { habitos: [] },
            patologicos: { patologicos = [] } = { patologicos: [] },
            quirurgicos: { quirurgicos = [] } = { quirurgicos: [] },
            farmacologicos: { farmacologicos = [] } = { farmacologicos: [] },
            inmunizaciones: { inmunizaciones = [] } = { inmunizaciones: [] },
            familiares: { familiares = [] } = { familiares: [] },
          } = currentAdmission.antecedentes || {};

          let tableInmuzations = inmunizaciones[0]
            ? inmunizaciones[0].hasOwnProperty("inmunizaciones")
              ? inmunizaciones[0].inmunizaciones.hasOwnProperty("table")
                ? inmunizaciones[0].inmunizaciones.table
                : []
              : []
            : [];
          let listInmunizations = tableInmuzations.reduce(
            (acc, cur, idx) =>
              tableInmuzations.length === idx + 1
                ? acc + cur.vacuna + " Fecha: " + cur.fecha
                : acc + cur.vacuna + " Fecha: " + cur.fecha + " | ",
            ""
          );
          let tablePharmacological = farmacologicos[0]
            ? farmacologicos[0].hasOwnProperty("farmacologico")
              ? farmacologicos[0].farmacologico.hasOwnProperty("table")
                ? farmacologicos[0].farmacologico.table
                : []
              : []
            : [];
          let listPharmacological = tablePharmacological.reduce(
            (acc, cur, idx) =>
              tablePharmacological.length === idx + 1
                ? acc + cur.principioactivo + " " + cur.concentracion
                : acc + cur.principioactivo + " " + cur.concentracion + " | ",
            ""
          );

          const {
            presion_arterial2 = "",
            peso = "",
            frecuencia_respiratoria = "",
            talla = "",
            presion_arterial = "",
            superficie_corporal = "",
            masa_corporal = "",
            aspecto_general = "",
            cabeza_cara = "",
            otorrino = "",
            ojos = "",
            cuello = "",
            torax = "",
            cardiovascular = "",
            pulmonar = "",
            abdomen = "",
            extremidades = "",
            neurologico = "",
            genitourinario = "",
            piel_faneras = "",
            frecuencia_cardiaca = "",
          } = currentAdmission.fisico || {};

          const {
            sintomas_generales = "",
            respiratorio = "",
            cardiovascular: cardiovascular_sistemas = "",
            gastrointestinal = "",
            genitourinario: genitourinario_sistemas = "",
            osteomuscular = "",
            dermatologico = "",
            endocrino = "",
            neurologico: neurologico_sistemas = "",
          } = currentAdmission.sistemas || {};

          const {
            hipertension: {
              value: value_hipertension = "No",
              comentario: comentario_hipertension = "",
            } = { value_hipertension: "No", comentario_hipertension: "" },
            metabolicos: {
              value: value_metabolicos = "No",
              comentario: comentario_metabolicos = "",
            } = { value_metabolicos: "No", comentario_metabolicos: "" },
            cardiacos: {
              value: value_cardiacos = "No",
              comentario: comentario_cardiacos = "",
            } = { value_cardiacos: "No", comentario_cardiacos: "" },
            infecciosos: {
              value: value_infecciosos = "No",
              comentario: comentario_infecciosos = "",
            } = { value_infecciosos: "No", comentario_infecciosos: "" },
            vasculares: {
              value: value_vasculares = "No",
              comentario: comentario_vasculares = "",
            } = { value_vasculares: "No", comentario_vasculares: "" },
            alergicos: {
              value: value_alergicos = "No",
              comentario: comentario_alergicos = "",
            } = { value_alergicos: "No", comentario_alergicos: "" },
            cancer: {
              value: value_cancer = "No",
              comentario: comentario_cancer = "",
            } = { value_cancer: "No", comentario_cancer: "" },
            transfusiones: {
              value: value_transfusiones = "No",
              comentario: comentario_transfusiones = "",
            } = { value_transfusiones: "No", comentario_transfusiones: "" },
            autoinmunes: {
              value: value_autoinmunes = "No",
              comentario: comentario_autoinmunes = "",
            } = { value_autoinmunes: "No", comentario_autoinmunes: "" },
            traumatico: {
              value: value_traumatico = "No",
              comentario: comentario_traumatico = "",
            } = { value_traumatico: "No", comentario_traumatico: "" },
            observation = "",
          } = patologicos[0] || {};

          const {
            quirurgico: {
              value: value_quirurgico = "No Refiere",
              comentario: comentario_quirurgico = "",
            } = { value_quirurgico: "No Refiere", comentario_quirurgico: "" },
            observation: observation_quirurgico = "",
          } = quirurgicos[0] || {};
          const {
            farmacologico: { value: value_farmacologico = "" } = {
              value_farmacologico: "",
            },
            observation: observation_farmacologico = "",
          } = farmacologicos[0] || {};
          const {
            inmunizaciones: { value: value_inmunizaciones = "" } = {
              value_inmunizaciones: "",
            },
            observation: observation_inmunizaciones = "",
          } = inmunizaciones[0] || {};
          const {
            cancer: {
              value: value_cancer_familiares = "No Refiere",
              comentario: comentario_cancer_familiares = "",
            } = {
              value_cancer_familiares: "",
              comentario_cancer_familiares: "",
            },
            diabetes: {
              value: value_diabetes_familiares = "No Refiere",
              comentario: comentario_diabetes_familiares = "",
            } = {
              value_diabetes_familiares: "",
              comentario_diabetes_familiares: "",
            },
            enf_coronaria: {
              value: value_enf_coronaria_familiares = "No Refiere",
              comentario: comentario_enf_coronaria_familiares = "",
            } = {
              value_enf_coronaria_familiares: "",
              comentario_enf_coronaria_familiares: "",
            },
            hipertension: {
              value: value_hipertension_familiares = "No Refiere",
              comentario: comentario_hipertension_familiares = "",
            } = {
              value_hipertension_familiares: "",
              comentario_hipertension_familiares: "",
            },
            muerte_subita: {
              value: value_muerte_subita_familiares = "No Refiere",
              comentario: comentario_muerte_subita_familiares = "",
            } = {
              value_muerte_subita_familiares: "",
              comentario_muerte_subita_familiares: "",
            },
            observation: observation_familiares = "",
          } = familiares[0] || {};

          let riesgoFumador = "";
          let ipa = "";
          const {
            paquetes_anio = 0,
            cocaina = "No",
            bazuco = "No",
            extasis = "No",
            heroina = "No",
            lcd = "No",
            hongos = "No",
            Hongos = "No",
            marihuana = "No",
            ghb = "No",
            fumador = "",
            humo_lena = "",
            sustancia_psico = "",
            alcohol = "",
            actividad_fisica = "",
            tiempo_anios = "",
            alcohol_frecuencia = "",
            actividades_cuales = [],
          } = habitos[0] || {};
          let cant_paquetes = !isNaN(paquetes_anio)
            ? paquetes_anio
            : paquetes_anio
            ? parseInt(paquetes_anio)
            : 0;
          if (cant_paquetes < 20) {
            ipa = cant_paquetes.toString();
            riesgoFumador = ipa + " IPA - Riesgo leve";
          } else if (cant_paquetes > 19 && cant_paquetes < 40) {
            ipa = cant_paquetes.toString();
            riesgoFumador = ipa + " IPA - Riesgo moderado";
          } else {
            ipa = cant_paquetes.toString();
            riesgoFumador = ipa + " IPA Riesgo alto";
          }

          let subtances = [];
          if (cocaina === "Si") {
            subtances.push("Cocaina");
          } else if (bazuco === "Si") {
            subtances.push("Bazuco");
          } else if (extasis === "Si") {
            subtances.push("Extasis");
          } else if (heroina === "Si") {
            subtances.push("Heroina");
          } else if (lcd === "Si") {
            subtances.push("LCD");
          } else if (hongos === "Si") {
            subtances.push("Hongos");
          } else if (marihuana === "Si") {
            subtances.push("Marihuana");
          } else if (ghb === "Si") {
            subtances.push("GHB");
          }

          docContent.push({
            margin: [0, 0, 0, 10],
            layout: {
              defaultBorder: false,
            },
            table: {
              headerRows: 1,
              widths: ["auto", 50, "*"],
              body: [
                [
                  {
                    text: "Antecedentes personales ",
                    style: "tableheader",
                    colSpan: 3,
                    border: [false, false, false, true],
                  },
                  "",
                  "",
                ],
                [{ text: "Patológicos: ", bold: true, fontSize: 10 }, "", ""],
                [
                  { text: "HIPERTENSIÓN -", style: "textStyle" },
                  { text: value_hipertension, style: "textStyle" },
                  { text: comentario_hipertension, style: "textStyle" },
                ],
                [
                  { text: "METÁBOLICOS -", style: "textStyle" },
                  { text: value_metabolicos, style: "textStyle" },
                  { text: comentario_metabolicos, style: "textStyle" },
                ],
                [
                  { text: "CARDIACOS -", style: "textStyle" },
                  { text: value_cardiacos, style: "textStyle" },
                  { text: comentario_cardiacos, style: "textStyle" },
                ],
                [
                  { text: "INFECCIOSOS", style: "textStyle" },
                  { text: value_infecciosos, style: "textStyle" },
                  { text: comentario_infecciosos, style: "textStyle" },
                ],
                [
                  { text: "VASCULARES -", style: "textStyle" },
                  { text: value_vasculares, style: "textStyle" },
                  { text: comentario_vasculares, style: "textStyle" },
                ],
                [
                  { text: "ALÉRGICOS -", style: "textStyle" },
                  { text: value_alergicos, style: "textStyle" },
                  {
                    text: listAlergies ? listAlergies : "",
                    style: "textStyle",
                  },
                ],
                [
                  { text: "CANCER -", style: "textStyle" },
                  { text: value_cancer, style: "textStyle" },
                  { text: comentario_cancer, style: "textStyle" },
                ],
                [
                  { text: "TRANSFUSIONES -", style: "textStyle" },
                  { text: value_transfusiones, style: "textStyle" },
                  { text: comentario_transfusiones, style: "textStyle" },
                ],
                [
                  { text: "AUTOINMUNES -", style: "textStyle" },
                  { text: value_autoinmunes, style: "textStyle" },
                  { text: comentario_autoinmunes, style: "textStyle" },
                ],
                [
                  { text: "TRAUMÁTICO -", style: "textStyle" },
                  { text: value_traumatico, style: "textStyle" },
                  { text: comentario_traumatico, style: "textStyle" },
                ],
                [
                  {
                    text: "OBSERVACIONES -",
                    style: "textStyle",
                    border: [false, false, false, true],
                  },
                  {
                    text: observation,
                    style: "textStyle",
                    colSpan: 2,
                    border: [false, false, false, true],
                  },
                  "",
                ],
                ["", "", ""],
                [
                  { text: "Quirúrgicos: ", bold: true, fontSize: 10 },
                  { text: value_quirurgico, style: "textStyle" },
                  { text: comentario_quirurgico, style: "textStyle" },
                ],
                [
                  {
                    text: "OBSERVACIONES -",
                    style: "textStyle",
                    border: [false, false, false, true],
                  },
                  {
                    text: observation_quirurgico,
                    style: "textStyle",
                    colSpan: 2,
                    border: [false, false, false, true],
                  },
                  "",
                ],
                [
                  { text: "Farmacológicos: ", bold: true, fontSize: 10 },
                  { text: value_farmacologico, style: "textStyle" },
                  { text: listPharmacological, style: "textStyle" },
                ],
                [
                  {
                    text: "OBSERVACIONES -",
                    style: "textStyle",
                    border: [false, false, false, true],
                  },
                  {
                    text: observation_farmacologico,
                    style: "textStyle",
                    colSpan: 2,
                    border: [false, false, false, true],
                  },
                  "",
                ],
                [
                  { text: "Inmunizaciones: ", bold: true, fontSize: 10 },
                  { text: value_inmunizaciones, style: "textStyle" },
                  { text: listInmunizations, style: "textStyle" },
                ],
                [
                  {
                    text: "OBSERVACIONES -",
                    style: "textStyle",
                    border: [false, false, false, true],
                  },
                  {
                    text: observation_inmunizaciones,
                    style: "textStyle",
                    colSpan: 2,
                    border: [false, false, false, true],
                  },
                  "",
                ],
                ["", "", ""],
                [{ text: "Familiares: ", bold: true, fontSize: 10 }, "", ""],
                [
                  { text: "CANCER -", style: "textStyle" },
                  { text: value_cancer_familiares, style: "textStyle" },
                  { text: comentario_cancer_familiares, style: "textStyle" },
                ],
                [
                  { text: "DIABETES -", style: "textStyle" },
                  { text: value_diabetes_familiares, style: "textStyle" },
                  { text: comentario_diabetes_familiares, style: "textStyle" },
                ],
                [
                  { text: "ENFERMEDAD CORONARIA -", style: "textStyle" },
                  { text: value_enf_coronaria_familiares, style: "textStyle" },
                  {
                    text: comentario_enf_coronaria_familiares,
                    style: "textStyle",
                  },
                ],
                [
                  { text: "HIPERTENSIÓN -", style: "textStyle" },
                  { text: value_hipertension_familiares, style: "textStyle" },
                  {
                    text: comentario_hipertension_familiares,
                    style: "textStyle",
                  },
                ],
                [
                  { text: "MUERTE SUBITA -", style: "textStyle" },
                  { text: value_muerte_subita_familiares, style: "textStyle" },
                  {
                    text: comentario_muerte_subita_familiares,
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text: "OBSERVACIONES -",
                    style: "textStyle",
                  },
                  {
                    text: observation_familiares,
                    style: "textStyle",
                    colSpan: 2,
                  },
                  "",
                ],
                ["", "", ""],
              ],
            },
          });
          docContent.push({
            unbreakable: true,
            margin: [0, 0, 0, 10],
            layout: {
              defaultBorder: false,
            },
            table: {
              headerRows: 1,
              widths: ["*", "*", "*", "*"],
              body: [
                [
                  {
                    text: "Antecedentes Hábitos",
                    style: "tableheader",
                    colSpan: 4,
                    border: [false, false, false, true],
                  },
                  "",
                  "",
                  "",
                ],
                [
                  { text: "Fumador: ", style: "textStyle", bold: true },
                  { text: fumador === "" ? "No" : fumador, style: "textStyle" },
                  {
                    text: "Índice de cigarrillos por año: ",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text: paquetes_anio === "" ? "" : riesgoFumador,
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text: "Exposición Humo de Leña : ",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text: humo_lena === "" ? "No" : humo_lena,
                    style: "textStyle",
                  },
                  {
                    text: "Años de Exposición: ",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text: tiempo_anios === "" ? "Ninguno" : tiempo_anios,
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text: "Sustancias Psicoactivas: ",
                    style: "textStyle",
                    bold: true,
                  },
                  { text: sustancia_psico, style: "textStyle" },
                  { text: "Sustancias: ", style: "textStyle", bold: true },
                  {
                    text:
                      sustancia_psico === "No"
                        ? sustancia_psico
                        : subtances.toString(),
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text: "Consumo de Alcohol:",
                    style: "textStyle",
                    bold: true,
                  },
                  { text: alcohol, style: "textStyle" },
                  {
                    text: "Consumo de Alcohol en el último año:",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text:
                      alcohol === "Si" ? " Frec." + alcohol_frecuencia : "No",
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text: "Actividad Física: ",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text: actividad_fisica,
                    style: "textStyle",
                  },
                  {
                    text: "Actividades/Frecuencia: ",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text:
                      actividades_cuales.length !== 0
                        ? actividades_cuales.toString()
                        : "",
                    style: "textStyle",
                  },
                ],
              ],
            },
          });
          if (currentAdmission.sistemas) {
            /* docContent.push(
                            {
                                margin: [0, 0, 0, 10],
                                layout: {
                                    defaultBorder: false,
                                },
                                table: {
                                    widths: ['auto', '*'],
                                    body: [
                                        [{ text: 'Revisión por sistema', style: 'tableheader', colSpan: 2, border: [false, false, false, true] }, ''],
                                        [{ text: 'Síntomas Generales: ', style: 'lineTittle' }, { text: sintomas_generales, style: 'textStyle' }],
                                        [{ text: 'Respiratorios: ', style: 'lineTittle' }, { text: respiratorio, style: 'textStyle' }],
                                        [{ text: 'Cardiovascular: ', style: 'lineTittle' }, { text: cardiovascular_sistemas, style: 'textStyle' }],
                                        [{ text: 'Gastrointestinal: ', style: 'lineTittle' }, { text: gastrointestinal, style: 'textStyle' }],
                                        [{ text: 'Genitourinario: ', style: 'lineTittle' }, { text: genitourinario_sistemas, style: 'textStyle' }],
                                        [{ text: 'Osteomuscular: ', style: 'lineTittle' }, { text: osteomuscular, style: 'textStyle' }],
                                        [{ text: 'Dermatologico: ', style: 'lineTittle' }, { text: dermatologico, style: 'textStyle' }],
                                        [{ text: 'Endocrino: ', style: 'lineTittle' }, { text: endocrino, style: 'textStyle' }],
                                        [{ text: 'Neurologico: ', style: 'lineTittle', border: [false, false, false, true] }, { text: neurologico_sistemas, style: 'textStyle', border: [false, false, false, true] }]
                                    ]
                                }
                            }
                        ); */
          }

          docContent.push({
            unbreakable: true,
            margin: [0, 0, 0, 10],
            layout: {
              defaultBorder: false,
            },
            table: {
              widths: ["auto", "*", "auto", "*"],
              headerRows: 1,
              body: [
                [
                  {
                    text: "Examen Físico ",
                    style: "tableheader",
                    colSpan: 4,
                    border: [false, false, false, true],
                  },
                  "",
                  "",
                  "",
                ],
                [
                  { text: "Género: ", style: "textStyle", bold: true },
                  { text: data.gender, style: "textStyle" },
                  {
                    text: "Frecuencia Cardíaca (lpm):",
                    style: "textStyle",
                    bold: true,
                  },
                  { text: frecuencia_cardiaca + " (lpm)", style: "textStyle" },
                ],
                [
                  { text: "Peso (kg):", style: "textStyle", bold: true },
                  { text: peso + " (kg)", style: "textStyle" },
                  {
                    text: "Frecuencia Respiratoria (resp/min):",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text: frecuencia_respiratoria + " (resp/min)",
                    style: "textStyle",
                  },
                ],
                [
                  { text: "Talla (cm): ", style: "textStyle", bold: true },
                  { text: talla + " (cm)", style: "textStyle" },
                  {
                    text: "Presiona Arterial:",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text:
                      presion_arterial + "/" + presion_arterial2 + " (mmHg)",
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text: "Superficie Corporal (mc):",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text: superficie_corporal + " (mc)",
                    style: "textStyle",
                  },
                  {
                    text: "Índice de Masa Corporal:",
                    style: "textStyle",
                    bold: true,
                  },
                  {
                    text: masa_corporal,
                    style: "textStyle",
                  },
                ],
              ],
            },
          });
          /* 
                    docContent.push(
                        {
                            margin: [0, 0, 0, 10],
                            layout: {
                                defaultBorder: false,
                            },
                            table: {
                                widths: ['auto', '*'],
                                body: [
                                    [{ text: 'Aspecto General: ', bold: true, fontSize: 10, border: [false, true, false, false] }, { text: aspecto_general, style: 'textStyle', border: [false, true, false, false] }],
                                    [{ text: 'Cabeza y Cara: ', bold: true, fontSize: 10, }, { text: cabeza_cara, style: 'textStyle' }],
                                    [{ text: 'Otorino: ', bold: true, fontSize: 10, }, { text: otorrino, style: 'textStyle' }],
                                    [{ text: 'Ojos: ', bold: true, fontSize: 10, }, { text: ojos, style: 'textStyle' }],
                                    [{ text: 'Cuello: ', bold: true, fontSize: 10, }, { text: cuello, style: 'textStyle' }],
                                    [{ text: 'Torax: ', bold: true, fontSize: 10, }, { text: torax, style: 'textStyle' }],
                                    [{ text: 'Cardiovascular ', bold: true, fontSize: 10, }, { text: cardiovascular, style: 'textStyle' }],
                                    [{ text: 'Pulmonar ', bold: true, fontSize: 10, }, { text: pulmonar, style: 'textStyle' }],
                                    [{ text: 'Abdomen ', bold: true, fontSize: 10, }, { text: abdomen, style: 'textStyle' }],
                                    [{ text: 'Extremidades ', bold: true, fontSize: 10, }, { text: extremidades, style: 'textStyle' }],
                                    [{ text: 'Neurologico ', bold: true, fontSize: 10, }, { text: neurologico, style: 'textStyle' }],
                                    [{ text: 'Genitourinatio ', bold: true, fontSize: 10, }, { text: genitourinario, style: 'textStyle' }],
                                    [{ text: 'Piel y Fanareas ', bold: true, fontSize: 10, border: [false, false, false, true] }, { text: piel_faneras, style: 'textStyle', border: [false, false, false, true] }],
                                ]
                            }
                        }
                    );*/
          console.log({ fisico: currentAdmission.fisico });
        } else {
          let costumBackgroundGeneralObservation =
            currentAdmission.antecedentes.hasOwnProperty("custom_background")
              ? currentAdmission.antecedentes.custom_background
                ? currentAdmission.antecedentes.custom_background.hasOwnProperty(
                    "costumBackground"
                  )
                  ? currentAdmission.antecedentes.custom_background.costumBackground.hasOwnProperty(
                      "generalObservation"
                    )
                    ? currentAdmission.antecedentes.custom_background
                        .costumBackground.generalObservation
                    : ""
                  : ""
                : ""
              : "";
          const {
            presion_arterial2 = "",
            peso = "",
            frecuencia_respiratoria = "",
            talla = "",
            presion_arterial = "",
            superficie_corporal = "",
            masa_corporal = "",
            aspecto_general = "",
            frecuencia_cardiaca = "",
          } = currentAdmission.fisico || {};

          docContent.push(
            {
              margin: [0, 0, 0, 10],
              layout: {
                defaultBorder: false,
              },
              table: {
                headerRows: 1,
                widths: ["auto", 50, "*"],
                body: [
                  [
                    {
                      text: "Antecedentes personales ",
                      style: "tableheader",
                      colSpan: 3,
                      border: [false, false, false, true],
                    },
                    "",
                    "",
                  ],
                  [
                    {
                      text: costumBackgroundGeneralObservation,
                      style: "textStyle",
                      colSpan: 3,
                    },
                    "",
                    "",
                  ],
                ],
              },
            },
            {
              margin: [0, 0, 0, 10],
              pageOrientation: "portrait",
              layout: {
                defaultBorder: false,
              },
              table: {
                widths: ["auto", "*"],
                body: [
                  [
                    {
                      text: "Aspecto General: ",
                      bold: true,
                      fontSize: 10,
                      border: [false, true, false, false],
                    },
                    {
                      text: aspecto_general,
                      style: "textStyle",
                      border: [false, true, false, false],
                    },
                  ],
                ],
              },
            },
            {
              unbreakable: true,
              margin: [0, 0, 0, 10],
              layout: {
                defaultBorder: false,
              },
              table: {
                widths: ["auto", "*", "auto", "*"],
                headerRows: 1,
                body: [
                  [
                    {
                      text: "Examen Fisico ",
                      style: "tableheader",
                      colSpan: 4,
                      border: [false, false, false, true],
                    },
                    "",
                    "",
                    "",
                  ],
                  [
                    { text: "Genero ", style: "textStyle", bold: true },
                    { text: data.gender, style: "textStyle" },
                    {
                      text: "Frecuencia Cardiaca (lpm)",
                      style: "textStyle",
                      bold: true,
                    },
                    {
                      text: frecuencia_cardiaca + " (lpm)",
                      style: "textStyle",
                    },
                  ],
                  [
                    { text: "Peso (kg)", style: "textStyle", bold: true },
                    { text: peso + " (kg)", style: "textStyle" },
                    {
                      text: "Frecuencia Respiratoria (resp/min)",
                      style: "textStyle",
                      bold: true,
                    },
                    {
                      text: frecuencia_respiratoria + " (resp/min)",
                      style: "textStyle",
                    },
                  ],
                  [
                    { text: "Talla (cm) ", style: "textStyle", bold: true },
                    { text: talla + " (cm)", style: "textStyle" },
                    {
                      text: "Presiona Arterial",
                      style: "textStyle",
                      bold: true,
                    },
                    {
                      text:
                        presion_arterial + "/" + presion_arterial2 + " (mmHg)",
                      style: "textStyle",
                    },
                  ],
                  [
                    {
                      text: "Superficie Corporal (mc)",
                      style: "textStyle",
                      bold: true,
                      border: [false, false, false, true],
                    },
                    {
                      text: superficie_corporal + " (mc)",
                      style: "textStyle",
                      border: [false, false, false, true],
                    },
                    {
                      text: "Índice de Masa Corporal",
                      style: "textStyle",
                      bold: true,
                      border: [false, false, false, true],
                    },
                    {
                      text: masa_corporal,
                      style: "textStyle",
                      border: [false, false, false, true],
                    },
                  ],
                ],
              },
            },
            currentAdmission.neurological_evaluation
              ? neurologicalEvaluation(currentAdmission.neurological_evaluation)
              : null
          );
        }

        if (currentAdmission.diagnostico) {
          const {
            diagnostico: { diagnostico = [] } = { diagnostico: [] },
            observaciones = "",
          } = currentAdmission.diagnostico;
          let tableDiagnostics = [];

          tableDiagnostics.push(
            [
              { text: "Diagnósticos ", style: "tableheader", colSpan: 2 },
              "",
              "",
              "",
            ],
            [
              { text: "CIE-10 ", bold: true, style: "textStyle" },
              { text: "Nombre", bold: true, style: "textStyle" },
              { text: "Tipo", bold: true, style: "textStyle" },
              { text: "Observación", bold: true, style: "textStyle" },
            ]
          );

          try {
            for (let k = 0; k < diagnostico.length; k++) {
              const element = diagnostico[k];
              const tipo = element.tipo;
              tableDiagnostics.push([
                { text: element.codigo, style: "textStyle" },
                { text: element.nombre, style: "textStyle" },
                { text: !!tipo ? tipo : "", style: "textStyle" },
                { text: element.observacion, style: "textStyle" },
              ]);
            }
          } catch (error) {
            console.log(error);
          }

          if (diagnostico.length) {
            docContent.push({
              unbreakable: true,
              margin: [0, 0, 0, 10],
              layout: "lightHorizontalLines",
              table: {
                widths: ["auto", "*", "*", "*"],
                headerRows: 1,
                body: tableDiagnostics,
                pageBreakBefore: function (
                  currentNode,
                  followingNodesOnPage,
                  nodesOnNextPage,
                  previousNodesOnPage
                ) {
                  return (
                    currentNode.headlineLevel === 1 &&
                    followingNodesOnPage.length === 0
                  );
                },
              },
            });
          }
          if (observaciones) {
            docContent.push(
              {
                text: "Observación Diagnósticos",
                style: "tableheader",
                layout: "lightHorizontalLines",
              },
              {
                text: currentAdmission.diagnostico.observaciones,
                style: "textStyle",
              }
            );
          }
        }
        if (currentAdmission.plan) {
          docContent.push({
            unbreakable: true,
            margin: [0, 0, 0, 10],
            layout: {
              defaultBorder: false,
            },
            table: {
              widths: [130, "*"],
              headerRows: 1,
              body: [
                [
                  {
                    text: "Análisis y Plan Médico ",
                    style: "tableheader",
                    border: [false, false, false, true],
                    colSpan: 2,
                  },
                  "",
                ],
                [
                  { text: "Análisis:", bold: true, fontSize: 10 },
                  { text: currentAdmission.plan.analisis, style: "textStyle" },
                ],
                [
                  { text: "Plan Médico:", bold: true, fontSize: 10 },
                  {
                    text: currentAdmission.plan.plan_medico,
                    style: "textStyle",
                  },
                ],
                [
                  {
                    text: "Recomendaciones:",
                    bold: true,
                    fontSize: 10,
                    border: [false, false, false, true],
                  },
                  {
                    text: currentAdmission.plan.recomendaciones,
                    style: "textStyle",
                    border: [false, false, false, true],
                  },
                ],
              ],
              pageBreakBefore: function (
                currentNode,
                followingNodesOnPage,
                nodesOnNextPage,
                previousNodesOnPage
              ) {
                return (
                  currentNode.headlineLevel === 1 &&
                  followingNodesOnPage.length === 0
                );
              },
            },
          });
        }
        if (currentAdmission.tratamiento) {
          const {
            ordenes: {
              ordenes: {
                addedDiagnostics = [],
                observationAndProcedure = "",
                formulas = [],
                medicalObservation = "",
                amount = [],
                observations = [],
              } = {
                addedDiagnostics: [],
                observationAndProcedure: "",
                formulas: [],
                medicalObservation: "",
                amount: [],
                observations: [],
              },
            } = {
              ordenes: {
                addedDiagnostics: [],
                observationAndProcedure: "",
                formulas: [],
                medicalObservation: "",
                amount: [],
                observations: [],
              },
            },
          } = currentAdmission.tratamiento || {};
          let tableBody = [];
          tableBody.push(
            [
              { text: "Ordenes Médicas ", style: "tableheader", colSpan: 2 },
              "",
              "",
              "",
            ],
            [
              { text: "CUPS", bold: true, fontSize: 10 },
              { text: "Nombre", bold: true, fontSize: 10 },
              { text: "Cantidad", bold: true, fontSize: 10 },
              { text: "Descripción", bold: true, fontSize: 10 },
            ]
          );
          try {
            for (let k = 0; k < addedDiagnostics.length; k++) {
              tableBody.push([
                { text: addedDiagnostics[k].cupscod, style: "textStyle" },
                { text: addedDiagnostics[k].cupsnom, style: "textStyle" },
                {
                  text: amount.length ? (amount[k] ? amount[k] : "") : "",
                  style: "textStyle",
                },
                {
                  text: observations.length
                    ? observations[k]
                      ? observations[k]
                      : ""
                    : "",
                  style: "textStyle",
                },
              ]);
            }
          } catch (e) {
            console.log(e);
          }

          if (addedDiagnostics.length) {
            docContent.push({
              unbreakable: true,
              margin: [0, 0, 0, 10],
              layout: "lightHorizontalLines",
              table: {
                widths: [80, "*", "auto", "auto"],
                headerRows: 1,
                body: tableBody,
              },
              pageBreakBefore: function (
                currentNode,
                followingNodesOnPage,
                nodesOnNextPage,
                previousNodesOnPage
              ) {
                return (
                  currentNode.headlineLevel === 1 &&
                  followingNodesOnPage.length === 0
                );
              },
            });
          }
          if (observationAndProcedure) {
            docContent.push(
              {
                text: "Observaciones de Exámenes/Consultas",
                style: "tableheader",
                layout: "lightHorizontalLines",
              },
              {
                text: observationAndProcedure,
                style: "textStyle",
              }
            );
          }
          if (formulas.length) {
            let tableBodyMedicine = [];

            tableBodyMedicine.push(
              [
                { text: "Medicamentos", style: "tableheader", colSpan: 2 },
                "",
                "",
                "",
                "",
                "",
                "",
                "",
              ],
              [
                { text: "Principio", bold: true, style: "textStyle" },
                { text: "Concentración", bold: true, style: "textStyle" },
                { text: "Forma Farmacéutica", bold: true, style: "textStyle" },
                { text: "Vía", bold: true, style: "textStyle" },
                { text: "Dosis", bold: true, style: "textStyle" },
                { text: "Frecuencia", bold: true, style: "textStyle" },
                { text: "Duración", bold: true, style: "textStyle" },
                { text: "Unidad", bold: true, style: "textStyle" },
              ]
            );

            try {
              for (let k = 0; k < formulas.length; k++) {
                tableBodyMedicine.push([
                  { text: formulas[k].activePrinciple, style: "textStyle" },
                  { text: formulas[k].concentration, style: "textStyle" },
                  { text: formulas[k].pharmaceuticalForm, style: "textStyle" },
                  { text: formulas[k].route, style: "textStyle" },
                  { text: formulas[k].dose, style: "textStyle" },
                  { text: formulas[k].frequency, style: "textStyle" },
                  { text: formulas[k].duration, style: "textStyle" },
                  { text: formulas[k].units, style: "textStyle" },
                ]);
              }
            } catch (error) {
              console.log(error);
            }

            docContent.push(
              {
                unbreakable: true,
                margin: [0, 0, 0, 10],
                layout: "lightHorizontalLines",
                table: {
                  widths: [
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                    "auto",
                    "*",
                  ],
                  headerRows: 1,
                  body: tableBodyMedicine,
                },
                pageBreakBefore: function (
                  currentNode,
                  followingNodesOnPage,
                  nodesOnNextPage,
                  previousNodesOnPage
                ) {
                  return (
                    currentNode.headlineLevel === 1 &&
                    followingNodesOnPage.length === 0
                  );
                },
              },
              {
                text:
                  medicalObservation === ""
                    ? ""
                    : "Observaciones de Medicamentos",
                style: "tableheader",
                style: "tableheader",
              },
              {
                text: medicalObservation,
                style: "textStyle",
              }
            );
          }
        }

        if (currentAdmission.audiometria) {
          let htmlSpeechTerapy = null;

          if (currentAdmission.audiometria) {
            htmlSpeechTerapy = htmlToPdfmake(
              currentAdmission.audiometria.fonoaudiologia
            );
          } else {
            htmlSpeechTerapy = null;
          }
          docContent.push(
            {
              unbreakable: true,
              margin: [0, 5, 0, 10],
              layout: "headerLineOnly",
              table: {
                widths: ["*", "*"],
                headerRows: 1,
                body: [
                  [{ text: "Audiometría ", style: "tableheader" }, ""],
                  [{ text: "", style: "tableheader" }, ""],
                ],
              },
            },
            htmlSpeechTerapy
          );
        }

        if (currentAdmission.notas_clinicas) {
          let tableClinicNotes = [];

          let notas = currentAdmission.notas_clinicas.filter(
            (nota) => nota.tipo_nota === "N"
          );

          tableClinicNotes.push(
            [
              {
                text: "Notas de Evoluciones",
                style: "tableheader",
              },
              "",
              "",
            ],
            [
              { text: "Fecha", bold: true, fontSize: 10 },
              { text: "Nota", bold: true, fontSize: 10 },
              { text: "Profesional", bold: true, fontSize: 10 },
            ]
          );

          try {
            for (let j = 0; j < notas.length; j++) {
              let url_doctor_nota_evolucion =
                process.env.REACT_APP_PUBLIC_URL +
                notas[j].firma_doctor +
                "/" +
                sessionStorage.getItem("token");
              const element = notas[j];

              tableClinicNotes.push([
                {
                  text: moment(element.fecha).format("YYYY-MM-DD HH:mm:ss"),
                  style: "textStyle",
                },
                { text: element.nota_clinica, style: "textStyle" },
                {
                  unbreakable: true,
                  layout: "headerLineOnly",
                  border: [false, false, false, false],
                  table: {
                    widths: [80],
                    headerRows: 1,
                    alignment: "left",
                    body: [
                      [
                        {
                          image: await getImage(url_doctor_nota_evolucion),
                          fit: [90, 40],
                          alignment: "left",
                        },
                      ],
                      [
                        {
                          text:
                            element.nombres +
                            " " +
                            element.apellido1 +
                            " " +
                            element.apellido2 +
                            "\n" +
                            (element.especialidad ?? element.cargo) +
                            (element.reg_medico
                              ? `\n REG- ${element.reg_medico}`
                              : ""),

                          style: "medicNote",
                        },
                      ],
                    ],
                  },
                },
              ]);
            }
          } catch (error) {
            console.log(error);
          }
          if (currentAdmission.notas_clinicas.length) {
            docContent.push({
              unbreakable: false,
              margin: [0, 0, 0, 10],
              layout: "headerLineOnly",
              table: {
                widths: ["auto", "auto", "*"],
                headerRows: 1,
                body: tableClinicNotes,
              },
            });
          }
        }

        if (currentAdmission.notas_clinicas) {
          let tableEpicrisis = [];
          if (currentAdmission.notas_clinicas) {
            let epicrisis = currentAdmission.notas_clinicas.filter(
              (epi) => epi.tipo_nota === "E"
            );
            tableEpicrisis.push(
              [{ text: "Epicrisis", style: "tableheader", colSpan: 2 }, "", ""],
              [
                { text: "Fecha", bold: true, fontSize: 10 },
                { text: "Nota", bold: true, fontSize: 10 },
                { text: "Profesional", bold: true, fontSize: 10 },
              ]
            );

            try {
              for (let j = 0; j < epicrisis.length; j++) {
                let url_doctor_nota_epicrisis =
                  process.env.REACT_APP_PUBLIC_URL +
                  epicrisis[j].firma_doctor +
                  "/" +
                  sessionStorage.getItem("token");
                const element = epicrisis[j];
                tableEpicrisis.push([
                  {
                    text: moment(element.fecha).format("YYYY-MM-DD HH:mm:ss"),
                    style: "textStyle",
                  },
                  { text: element.nota_clinica, style: "textStyle" },
                  {
                    unbreakable: true,
                    layout: "headerLineOnly",
                    border: [false, false, false, false],
                    table: {
                      widths: [80],
                      headerRows: 1,
                      alignment: "left",
                      body: [
                        [
                          {
                            image: await getImage(url_doctor_nota_epicrisis),
                            fit: [90, 40],
                            alignment: "left",
                          },
                        ],
                        [
                          {
                            text:
                              "Dr. " +
                              element.nombres +
                              " " +
                              element.apellido1 +
                              " " +
                              element.apellido2 +
                              "\n" +
                              (element.especialidad ?? element.cargo) +
                              (element.reg_medico
                                ? `\n REG- ${element.reg_medico}`
                                : ""),

                            style: "medicNote",
                          },
                        ],
                      ],
                    },
                  },
                ]);
              }
            } catch (error) {
              console.log(error);
            }
          }

          if (
            currentAdmission.notas_clinicas.length /* && printCurrentHistor */
          ) {
            docContent.push({
              unbreakable: true,
              margin: [0, 0, 0, 10],
              layout: "lightHorizontalLines",
              table: {
                widths: ["auto", "auto", "*"],
                headerRows: 1,
                body: tableEpicrisis,
              },
            });
          }
        }

        console.log(i + 1 === lengthAdmissions ? "" : "after");
        /* docContent.push(
          {
                        margin: [0, 60, 0, 0],
                        image: await getImage(admissionSignature),
                        fit: [80, 80],
                    }, 
                    // {
                    //     unbreakable: true,
                    //     pageBreak: (i + 1) === lengthAdmissions ? '' : 'after',
                    //     text: 'Dr. ' + currentAdmission.nombres + ' ' + currentAdmission.apellido1 + ' ' + currentAdmission.apellido2 + '\n'
                    //         + currentAdmission.especialidad + '\n REG-' + currentAdmission.reg_medico, style: 'medicStyle'
                    // }
          {
            //columns: signatures2,
          }
        ); */
      }
    } catch (error) {
      console.log(error);
    }

    try {
      if (currentAdmission.procedimientos) {
        let resultsPocedures = [];
        if (
          currentAdmission.procedimientos.eco.hasOwnProperty("eco") ||
          currentAdmission.procedimientos.estres.hasOwnProperty("estres") ||
          currentAdmission.procedimientos.prueba.hasOwnProperty("prueba") ||
          currentAdmission.procedimientos.ekg.hasOwnProperty("ekg") ||
          currentAdmission.procedimientos.holter.hasOwnProperty("holter") ||
          currentAdmission.procedimientos.mapa.hasOwnProperty("mapa")
        ) {
          let resultOtherProcedureEco = (await validateProcessECO(
            currentAdmission.procedimientos.eco.eco[0]
          ))
            ? currentAdmission.procedimientos.eco.eco[0].conclusiones
            : null;
          let resultOtherProcedureEstres = (await validateProcessEstres(
            currentAdmission.procedimientos.estres.estres[0]
          ))
            ? currentAdmission.procedimientos.estres.estres[0].conclusiones
            : null;
          let resultOtherProcedurePrueba = (await validateProcessPrueba(
            currentAdmission.procedimientos.prueba.prueba[0]
          ))
            ? currentAdmission.procedimientos.prueba.prueba[0].conclusiones
            : null;
          let resultOtherProcedureEkg = (await validateProcessEKG(
            currentAdmission.procedimientos.ekg.ekg[0]
          ))
            ? currentAdmission.procedimientos.ekg.ekg[0].conclusions !==
                undefined &&
              currentAdmission.procedimientos.ekg.ekg[0].conclusions !== null
              ? currentAdmission.procedimientos.ekg.ekg[0].conclusions
              : currentAdmission.procedimientos.ekg.ekg[0].conclusion !==
                  undefined &&
                currentAdmission.procedimientos.ekg.ekg[0].conclusion !== null
              ? currentAdmission.procedimientos.ekg.ekg[0].conclusion
              : null
            : null;
          let resultOtherProcedureHolter = (await validateProcessHolter(
            currentAdmission.procedimientos.holter.holter[0]
          ))
            ? currentAdmission.procedimientos.holter.holter[0].conclusion
            : null;
          let resultOtherProcedureMapa = (await validateProcessMapa(
            currentAdmission.procedimientos.mapa.mapa[0]
          ))
            ? currentAdmission.procedimientos.mapa.mapa[0].conclusion
            : null;

          if (resultOtherProcedureEco !== null) {
            let nameServ = currentAdmission.cita.servicio.servicios.filter(
              (serv) => serv.formato === "1"
            );
            if (nameServ.length) {
              resultsPocedures.push({
                ["service_name"]: nameServ[0].nombre,
                ["code_cups"]: nameServ[0].codigo,
                ["result_procedure"]: resultOtherProcedureEco,
              });
            }
          }
          if (resultOtherProcedureEstres !== null) {
            let nameServ = currentAdmission.cita.servicio.servicios.filter(
              (serv) => serv.formato === "3"
            );
            if (nameServ.length) {
              resultsPocedures.push({
                ["service_name"]: nameServ[0].nombre,
                ["code_cups"]: nameServ[0].codigo,
                ["result_procedure"]: resultOtherProcedureEstres,
              });
            }
          }
          if (resultOtherProcedurePrueba !== null) {
            let nameServ = currentAdmission.cita.servicio.servicios.filter(
              (serv) => serv.formato === "4"
            );
            if (nameServ.length) {
              resultsPocedures.push({
                ["service_name"]: nameServ[0].nombre,
                ["code_cups"]: nameServ[0].codigo,
                ["result_procedure"]: resultOtherProcedurePrueba,
              });
            }
          }
          if (resultOtherProcedureEkg !== null) {
            let nameServ = currentAdmission.cita.servicio.servicios.filter(
              (serv) => serv.formato === "2"
            );
            if (nameServ.length) {
              resultsPocedures.push({
                ["service_name"]: nameServ[0].nombre,
                ["code_cups"]: nameServ[0].codigo,
                ["result_procedure"]: resultOtherProcedureEkg,
              });
            }
          }
          if (resultOtherProcedureHolter !== null) {
            let nameServ = currentAdmission.cita.servicio.servicios.filter(
              (serv) => serv.formato === "6"
            );
            if (nameServ.length) {
              resultsPocedures.push({
                ["service_name"]: nameServ[0].nombre,
                ["code_cups"]: nameServ[0].codigo,
                ["result_procedure"]: resultOtherProcedureHolter,
              });
            }
          }
          if (resultOtherProcedureMapa !== null) {
            let nameServ = currentAdmission.cita.servicio.servicios.filter(
              (serv) => serv.formato === "7"
            );
            if (nameServ.length) {
              resultsPocedures.push({
                ["service_name"]: nameServ[0].nombre,
                ["code_cups"]: nameServ[0].codigo,
                ["result_procedure"]: resultOtherProcedureMapa,
              });
            }
          }
        }

        if (resultsPocedures.length > 0) {
          let tableBodyOtherProcedures = [];
          try {
            for (let k = 0; k < resultsPocedures.length; k++) {
              const search = "\n";
              const replaceWith = "<br />";
              const result = resultsPocedures[k].result_procedure
                .split(search)
                .join(replaceWith);
              //let htmlProceduresConclusion = htmlToPdfmake(result);
              let htmlProceduresConclusion = htmlToPdfmake(result, {
                defaultStyles: {
                  table: {
                    width: ["*", "auto"],
                  },
                },
                tableAutoSize: true,
              });

              tableBodyOtherProcedures.push(
                [{ text: "Procedimiento: ", style: "tableheader" }, ""],
                [
                  {
                    text:
                      resultsPocedures[k].code_cups +
                      " " +
                      resultsPocedures[k].service_name,
                    bold: true,
                    alignment: "left",
                    colSpan: 2,
                    style: "textStyle",
                  },
                  "",
                ],
                [htmlProceduresConclusion, ""]
              );
            }
          } catch (error) {
            console.log(error);
          }

          docContent.push(basicPatientInfo(), {
            margin: [0, 5, 0, 5],
            unbreakable: true,
            layout: "noBorders",
            table: {
              headerRows: 1,
              widths: ["auto", "*"],
              body: tableBodyOtherProcedures,
            },
          });
        }
      }
    } catch (error) {
      console.log(error);
    }

    if (currentAdmission.transcripcion) {
      //let admissionSignature = await printSignature(currentAdmission);
      let nameService = currentAdmission.cita.hasOwnProperty("servicio")
        ? currentAdmission.cita.servicio.hasOwnProperty("servicios")
          ? currentAdmission.cita.servicio.servicios.length > 0
            ? currentAdmission.cita.servicio.servicios[0].cupscod +
              " " +
              currentAdmission.cita.servicio.servicios[0].nombre
            : ""
          : ""
        : "";
      docContent.push(
        basicPatientInfo(),
        {
          margin: [0, 5, 0, 5],
          layout: "noBorders",
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            body: [
              [{ text: "Procedimiento Gamagrafía", style: "tableheader" }, ""],
              [
                {
                  text: nameService,
                  bold: true,
                  alignment: "left",
                  colSpan: 2,
                  style: "textStyle",
                },
                "",
              ],
              [
                {
                  text: currentAdmission.transcripcion.transcripcion,
                  style: "textStyle",
                  colSpan: 2,
                },
                "",
              ],
            ],
          },
        },
        /* {
                    margin: [0, 60, 0, 0],
                    image: await getImage(admissionSignature),
                    fit: [80, 80],
                }, */
        {
          // unbreakable: true,
          // pageBreak: 'after',
          // text: 'Dr. ' + currentAdmission.nombres + ' ' + currentAdmission.apellido1 + ' ' + currentAdmission.apellido2 + '\n'
          //     + currentAdmission.especialidad + '\n REG-' + currentAdmission.reg_medico, style: 'medicStyle'
          //columns: signatures2,
        }
      );
    }

    if (
      currentAdmission.radiofarmaco.length > 0 ||
      currentAdmission.registro_clinico
    ) {
      docContent.push(basicPatientInfo());
    }

    //Medicamento Nuclear en la Historia Clinica
    if (currentAdmission.radiofarmaco.length > 0) {
      if (clinicType.includes("3")) {
        const tableBody = [
          [
            {
              text: "Aplicación del radiofármaco",
              colSpan: 4,
              style: "tableheader",
              border: [false, false, false, true],
            },
            "",
            "",
            "",
          ],
        ];

        for (let j = 0; j < currentAdmission.radiofarmaco.length; j++) {
          const element = currentAdmission.radiofarmaco[j];

          tableBody.push([
            {
              text: "Nombre del Medicamento: ",
              style: "textStyle",
              bold: true,
            },
            {
              text: element.nombre_medicamento,
              style: "textStyle",
            },
            {
              text: "Fecha de Aplicación: ",
              style: "textStyle",
              bold: true,
            },
            {
              text: moment(element.fecha_aplicacion).format(
                "DD-MM-YYYY H:mm a"
              ),
              style: "textStyle",
            },
          ]);

          tableBody.push([
            {
              text: "Dosis y unidad de medida: ",
              style: "textStyle",
              bold: true,
            },
            {
              text: element.dosis,
              style: "textStyle",
            },
            {
              text: "Observación: ",
              style: "textStyle",
              bold: true,
            },
            {
              text: element.observacion,
              style: "textStyle",
            },
          ]);
          tableBody.push(["", "", "", ""]);
          tableBody.push([{}, {}, {}, {}]);
        }

        docContent.push({
          unbreakable: true,
          margin: [0, 10, 0, 10],
          layout: {
            defaultBorder: false,
          },
          table: {
            headerRows: 1,
            widths: ["auto", "*", "auto", "*"],
            body: tableBody,
          },
        });
      }
    } else {
      console.log("no tiene radiofarmaco");
    }

    //Los Registros Clinicos se muestran en la Historia Clinica
    if (currentAdmission.registro_clinico) {
      docContent.push({
        unbreakable: true,
        margin: [0, 10, 0, 10],
        layout: "headerLineOnly",
        table: {
          headerRows: 1,
          widths: ["*", "*", "*", "*"],
          body: [
            [
              {
                text: "Impresión Diagnostica",
                colSpan: 2,
                style: "tableheader",
              },
              "",
              "",
              "",
            ],
            [{ text: "", style: "textStyle", bold: true }, "", "", ""],
          ],
        },
      });

      docContent.push({
        margin: [0, 0, 0, 10],
        text: currentAdmission.registro_clinico.impresion_diagnostica,
        style: "textStyle",
      });

      docContent.push({
        unbreakable: true,
        margin: [0, 10, 0, 10],
        layout: "headerLineOnly",
        table: {
          headerRows: 1,

          widths: ["*", "*", "*", "*"],
          body: [
            [
              {
                text: "Diagnósticos de Ingreso",
                colSpan: 2,
                style: "tableheader",
              },
              "",
              "",
              "",
            ],
            [{ text: "", style: "textStyle", bold: true }, "", "", ""],
          ],
        },
      });

      let entrevista_paciente = {
        alergias:
          currentAdmission.registro_clinico.entrevista.alergias == true
            ? "X"
            : "",
        asma:
          currentAdmission.registro_clinico.entrevista.asma == true ? "X" : "",
        marca_paso:
          currentAdmission.registro_clinico.entrevista.marca_paso == true
            ? "X"
            : "",
        implante:
          currentAdmission.registro_clinico.entrevista.implante == true
            ? "X"
            : "",
        protesis:
          currentAdmission.registro_clinico.entrevista.protesis == true
            ? "X"
            : "",
        bomba_infusion:
          currentAdmission.registro_clinico.entrevista.bomba_infusion == true
            ? "X"
            : "",
        operado:
          currentAdmission.registro_clinico.entrevista.operado == true
            ? "X"
            : "",
        embarazo:
          currentAdmission.registro_clinico.entrevista.embarazo == true
            ? "X"
            : "",
        puentes_dentales:
          currentAdmission.registro_clinico.entrevista.puentes_dentales == true
            ? "X"
            : "",
        objetos_metalicos:
          currentAdmission.registro_clinico.entrevista.objetos_metalicos == true
            ? "X"
            : "",
      };

      docContent.push(
        {
          margin: [0, 5],
          columns: [
            {
              width: "*",
              text: "Alergias ( " + entrevista_paciente.alergias + " )",
              style: "textStyle",
            },
            {
              width: "*",
              text: "Asma  (  " + entrevista_paciente.asma + " )",
              style: "textStyle",
            },
            {
              width: "*",
              text: "Marca Paso (  " + entrevista_paciente.marca_paso + " )",
              style: "textStyle",
            },
          ],
        },
        {
          margin: [0, 5],
          columns: [
            {
              width: "*",
              text: "Implante ( " + entrevista_paciente.implante + " )",
              style: "textStyle",
            },
            {
              width: "*",
              text: "Protesis  ( " + entrevista_paciente.protesis + " )",
              style: "textStyle",
            },
            {
              width: "*",
              text:
                "Bomba Infusion ( " + entrevista_paciente.bomba_infusion + " )",
              style: "textStyle",
            },
          ],
        },
        {
          margin: [0, 5],
          columns: [
            {
              width: "*",
              text: "Operado   ( " + entrevista_paciente.operado + " )",
              style: "textStyle",
            },
            data.gender.toUpperCase() == "FEMENINO"
              ? {
                  width: "*",
                  text: "Embarazo  ( " + entrevista_paciente.embarazo + " )",
                  style: "textStyle",
                }
              : null,
            {
              width: "*",
              text:
                "Puentes Dentales  ( " +
                entrevista_paciente.puentes_dentales +
                " )",
              style: "textStyle",
            },
          ],
        },
        {
          margin: [0, 5],
          columns: [
            {
              width: "*",
              text:
                "Objetos Metálicos ( " +
                entrevista_paciente.objetos_metalicos +
                " )",
              style: "textStyle",
            },
            {
              width: "*",
              text: "",
              style: "textStyle",
            },
            {
              width: "*",
              text: "",
              style: "textStyle",
            },
          ],
        },
        {
          margin: [0, 10, 0, 5],
          text:
            "Antecedentes Registro Clínico: \n " +
            currentAdmission.registro_clinico.entrevista.otros_sintomas_text,
          style: "textStyle",
        }
      );
    }

    if (currentAdmission?.anamnesis) {
      docContent.push({
        columns: signatures2,
        signatures,
      });
    }

    if (printCurrentHistory) {
      break;
    }
  }

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    pageMargins: [20, 50, 20, 20],
    defaultStyle: {
      fontSize: 8,
      alignment: "left",
    },
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "head",
              },
              { text: name, style: "head" },
              { text: "Fecha Impresión: " + fecha, style: "head" },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 0, 5],
      };
    },
    content: docContent,
    styles: {
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      lineTittle: {
        fontSize: 10,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 11,
        bold: true,
      },
      textStyle: {
        fontSize: 9,
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
      },
      foter: {
        alignment: "center",
        fontSize: 6,
      },
      medicStyle: {
        fontSize: 7,
        alignment: "center",
        bold: true,
        font: "Roboto",
      },
      medicNote: {
        fontSize: 7,
        alignment: "center",
        bold: true,
        font: "Roboto",
      },
      textRepresentandCompanion: {
        fontSize: 10,
      },
    },
  };

  //pdfMake.createPdf(documentDefinition).open();
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  switch (opt) {
    case "PDF": //Muestra el PDF en SAC
      pdfDocGenerator.getBlob((blob) => {
        const url = URL.createObjectURL(blob);
        document.getElementById("pdfV").src = url;
      });
      break;
    case "Email": //Envia el PDF por Correo Electronico
      pdfDocGenerator.getBuffer(function (buffer) {
        var blob = new Blob([buffer], { type: "application/pdf" });
        let namePatient = data.names;
        let fileName = `Historia Clinica_${namePatient}.pdf`;
        var filePDF = new File([blob], fileName, {
          lastModified: new Date().getTime(),
          type: blob.type,
        });
        sendPDFToEmail(
          fileName,
          filePDF,
          `Historia Clinica - ${namePatient}`,
          emailsDestiny
        )
          .then((responseSended) => {
            //alert("Correo Enviado Exitosamente");
          })
          .catch((err) => {
            console.log(err);
            alert("Ha ocurrido un error en el Servidor");
          });
      });
      break;
    default:
      pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById("pdfV").src = outDoc;
      });
      break;
  }

  function findInlineHeight(cell, maxWidth, usedWidth = 0) {
    function mapTableBodies(innerTableCell) {
      const inlineHeight = findInlineHeight(
        innerTableCell,
        maxWidth,
        usedWidth
      );

      usedWidth = inlineHeight.width;
      return inlineHeight.height;
    }
    let calcLines = (inlines) => {
      if (!inlines)
        return {
          height: 0,
          width: 0,
        };
      let currentMaxHeight = 0;
      let lastHadLineEnd = false;
      for (const currentNode of inlines) {
        usedWidth += currentNode.width;
        if (usedWidth > maxWidth || lastHadLineEnd) {
          currentMaxHeight += currentNode.height;
          usedWidth = currentNode.width;
        } else {
          currentMaxHeight = Math.max(currentNode.height, currentMaxHeight);
        }
        lastHadLineEnd = !!currentNode.lineEnd;
      }
      return {
        height: currentMaxHeight,
        width: usedWidth,
      };
    };
    if (cell._offsets) {
      usedWidth += cell._offsets.total;
    }
    if (cell._inlines && cell._inlines.length) {
      return calcLines(cell._inlines);
    } else if (cell.stack && cell.stack[0]) {
      return cell.stack
        .map((item) => {
          return findInlineHeight(item, maxWidth);
        })
        .reduce((prev, next) => {
          return {
            height: prev.height + next.height,
            width: Math.max(prev.width + next.width),
          };
        });
    } else if (cell.table) {
      let currentMaxHeight = 0;
      for (const currentTableBodies of cell.table.body) {
        const innerTableHeights = currentTableBodies.map(mapTableBodies);
        currentMaxHeight = Math.max(...innerTableHeights, currentMaxHeight);
      }
      return {
        height: currentMaxHeight,
        width: usedWidth,
      };
    } else if (cell._height) {
      usedWidth += cell._width;
      return {
        height: cell._height,
        width: usedWidth,
      };
    }

    return {
      height: null,
      width: usedWidth,
    };
  }

  function applyVerticalAlignment(node, rowIndex, align, manualHeight = 0) {
    // New default argument
    const allCellHeights = node.table.body[rowIndex].map(
      (innerNode, columnIndex) => {
        if (innerNode._span) return null;
        const calcWidth = [...Array(innerNode.colSpan || 1).keys()].reduce(
          (acc, i) => {
            return acc + node.table.widths[columnIndex + i]._calcWidth;
          },
          0
        );
        const mFindInlineHeight = findInlineHeight(
          innerNode,
          calcWidth,
          0,
          rowIndex,
          columnIndex
        );
        return mFindInlineHeight.height;
      }
    );
    const maxRowHeight = manualHeight
      ? manualHeight[rowIndex]
      : Math.max(...allCellHeights); // handle manual height
    node.table.body[rowIndex].forEach((cell, ci) => {
      if (allCellHeights[ci] && maxRowHeight > allCellHeights[ci]) {
        let topMargin;

        let cellAlign = align;
        if (Array.isArray(align)) {
          cellAlign = align[ci];
        }

        if (cellAlign === "bottom") {
          topMargin = maxRowHeight - allCellHeights[ci];
        } else if (cellAlign === "center") {
          topMargin = (maxRowHeight - allCellHeights[ci]) / 2;
        }

        if (topMargin) {
          if (cell._margin) {
            cell._margin[1] = topMargin;
          } else {
            cell._margin = [0, topMargin, 0, 0];
          }
        }
      }
    });
  }
};

export default clinicHystoryPDF;
